import { createTheme, Theme } from "@mui/material"
import { createBaseTheme } from "./createBaseTheme"
import { loadTheme } from "./catalogs"
import { NextTheme } from "./themeTypes/next"
import { CustomThemeCreator } from "./types"

// Remove the unnecessary single quotes, usually used in fontFamily. They would cause errors in css
function removeSingleQuotes(theme: NextTheme): NextTheme {
    let json = JSON.stringify(theme)
    json = json.replaceAll(/("'|'")/g, '"')
    return JSON.parse(json)
}

/** Override Mui Default Colors if included in next Theme */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const createMuiTheme = async (theme: NextTheme): Promise<Theme> => {
    const nextTheme = removeSingleQuotes(theme)
    const baseTheme = createBaseTheme(nextTheme)

    if (!baseTheme.name) {
        return baseTheme
    }

    let createCatalogTheme: CustomThemeCreator | undefined
    try {
        const themeModule = await loadTheme(nextTheme.name)
        createCatalogTheme = themeModule?.createTheme
    } catch {
        console.warn(`⚠️ no Theme for Catalog "${nextTheme.name}" found! use Base-Theme.`)
        return baseTheme
    }

    return typeof createCatalogTheme === "function" ? createTheme(baseTheme, { components: createCatalogTheme(baseTheme) }) : baseTheme
}
